import React, { useState, useEffect } from 'react';
import styled, { css } from 'react-emotion';
import UIMaxWidth from '../Layout/MaxWidth';
import { LoadingLine } from '@jetshop/ui/Loading/LoadingLine';
import Image from '@jetshop/ui/Image/Image';
import ChannelContext from '@jetshop/core/components/ChannelContext';

import SwedenFlagSRC from '../../images/sweden-flag.png';
import $ from 'jquery';

const StoreWrapper = styled(UIMaxWidth)`
  .resellers-wrapper {
    //overflow: hidden;
    ${({ theme }) => theme.below.md} {
      margin-left: -10px;
      margin-right: -10px;
    }
  }

  .top-buttons-container {
    display: none !important;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid $grey-medium-darker;
    ${({ theme }) => theme.below.md} {
      padding: 0 10px;
    }
    & > div {
      display: inline-block;
    }
    .button-right {
      //margin-left: 32px;
    }
  }

  .top-buttons-container,
  .reseller-countries {
    margin: 0 -1rem;
  }

  .reseller-countries {
    display: none !important;
    text-align: center;
    margin-top: 30px;
    display: -webkit-flex;
    display: -ms-flex;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    ${({ theme }) => theme.below.md} {
      padding: 0 10px;
    }
  }

  .reseller-country-filter {
    //margin: 0 0.3em 0.6em 0.3em;
    width: 200px;
    margin: 0.65em 1rem;
    border: 0;
    padding: 0.5em 1em;
    border-radius: 0;
    font-size: 1rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: ${({ theme }) => theme.colors.themeBlack};
    background: ${({ theme }) => theme.colors.themeGrey};
    cursor: pointer;
    font-family: $font-family-sans-serif;
    ${({ theme }) => theme.below.md} {
      width: 48%;
    }
  }

  .reseller-country-filter.active {
    color: #f2f2f2;
    background: ${({ theme }) => theme.colors.themeBlack};
  }

  .reseller-country-filter:focus {
    //outline: 1px solid #000;
    outline: none;
  }

  .resellers-search-form {
    position: relative;
    text-align: center;
    margin: 15px auto 0 auto;
    max-width: 260px;

    &:after {
      width: 15px;
      height: 10px;
      position: absolute;
      right: 10px;
      top: 12px;
      font-weight: normal;
      content: '';
      font-size: 0.75rem;
      background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNS4xMTMiIGhlaWdodD0iOS4xNzIiIHZpZXdCb3g9IjAgMCAxNS4xMTMgOS4xNzIiPiAgPHBhdGggaWQ9ImNoZXZyb24tZG93biIgZD0iTTYuOTY5LDguOTI4LjI0MywyLjJhLjgzMS44MzEsMCwwLDEsMC0xLjE3NUwxLjAyOC4yNDNBLjgzMS44MzEsMCwwLDEsMi4yLjI0Mmw1LjM1Niw1LjMzTDEyLjkxMi4yNDJhLjgzMS44MzEsMCwwLDEsMS4xNzMsMGwuNzg0Ljc4NGEuODMxLjgzMSwwLDAsMSwwLDEuMTc1TDguMTQ0LDguOTI4YS44MzEuODMxLDAsMCwxLTEuMTc1LDBaIi8+PC9zdmc+);
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      transform: rotate(-90deg);
    }
  }

  .resellers-search-input {
    width: 100%;
    border: 0;
    padding: 0.5em 2em 0.5em 1em;
    font-size: 1rem;
    background: ${({ theme }) => theme.colors.themeGreyLight};
    outline: none;
    transition: all ease-in-out 0.2s;
    &:active,
    &:focus {
      background: #ececec;
    }
    ${({ theme }) => theme.below.sm} {
      width: 100%;
    }
  }

  .resellers-table {
    width: 100%;
    margin-top: 3em;
    margin-bottom: 2em;
    border-top: 1px solid ${({ theme }) => theme.colors.themeGreyMediumDark};
    ${({ theme }) => theme.below.md} {
      padding: 0 10px;
    }
  }

  .resellers-head {
    ${({ theme }) => theme.below.md} {
      display: block;
    }
  }

  .retailer-title {
    display: table-cell;

    padding: 15px 9px;
    font-size: 1rem;
    font-weight: normal;
    text-transform: uppercase;
    text-align: left;
    letter-spacing: 2px;
    ${({ theme }) => theme.below.md} {
      display: none;
      &:nth-of-type(1) {
        display: block;
      }
      // &:nth-of-type(2) {
      //   display: inline-block;
      // }
    }
  }

  .reseller-row {
    display: table-row;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.themeBlack};
    > .col:first-of-type {
      position: relative;
      &:before {
        content: '';
        display: block;
        height: 10px;
        width: 16px;
        position: absolute;
        left: -16px;
        top: 8px;
        background: url(${SwedenFlagSRC});
        background-size: contain;
        background-repeat: no-repeat;
        ${({ theme }) => theme.below.md} {
          top: 20px;
        }
      }
    }
    ${({ theme }) => theme.below.md} {
      display: block;
      position: relative;
      .empty-col {
        display: none;
      }
      &:after {
        width: 15px;
        height: 10px;
        position: absolute;
        top: 22px;
        right: 10px;
        content: '';
        color: ${({ theme }) => theme.colors.themeBlack};
        display: inline-block;
        font-size: 1.7rem;
        transform: rotate(-90deg);
        transition: all ease-in-out 0.2s;
        background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNS4xMTMiIGhlaWdodD0iOS4xNzIiIHZpZXdCb3g9IjAgMCAxNS4xMTMgOS4xNzIiPiAgPHBhdGggaWQ9ImNoZXZyb24tZG93biIgZD0iTTYuOTY5LDguOTI4LjI0MywyLjJhLjgzMS44MzEsMCwwLDEsMC0xLjE3NUwxLjAyOC4yNDNBLjgzMS44MzEsMCwwLDEsMi4yLjI0Mmw1LjM1Niw1LjMzTDEyLjkxMi4yNDJhLjgzMS44MzEsMCwwLDEsMS4xNzMsMGwuNzg0Ljc4NGEuODMxLjgzMSwwLDAsMSwwLDEuMTc1TDguMTQ0LDguOTI4YS44MzEuODMxLDAsMCwxLTEuMTc1LDBaIi8+PC9zdmc+);
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
      }
      &.no-tab {
        &:after {
          display: none;
        }
      }
      &.active-tab {
        &:after {
          transform: rotate(0deg) translateY(-3px);
        }
      }

      & > div {
        display: none;
      }
      & > div:nth-child(1),
      & > div:nth-child(2) {
        display: block;
      }
      & > div:nth-child(1) {
        font-size: 0.9rem;
        text-transform: uppercase;
        color: ${({ theme }) => theme.colors.themeBlack};
        padding-bottom: 0;
      }
      & > div:nth-child(2) {
        padding-top: 0.1rem;
        padding-left: 0.7rem;
        padding-bottom: 0.5rem;
        font-size: 1rem;
        font-weight: 500;
      }
    }
    a {
      font-weight: 400;
      text-transform: lowercase;
      font-size: 13px;
    }
  }

  .mobile-reseller-tab {
    padding-bottom: 15px;
    ${({ theme }) => theme.above.md} {
      display: none !important;
    }
    ${({ theme }) => theme.below.md} {
      display: block;
    }
    & > div {
      display: block;
      &:nth-child(1),
      &:nth-child(2) {
        display: none;
      }
    }

    .reseller-location,
    .reseller-phone,
    .reseller-link {
      font-size: 1rem;
      padding: 0.2rem 0.5rem;
      text-transform: none;
      a {
        font-size: 1rem;
      }
      &:before {
        //display: inline-block;
        display: none;
        font-family: 'noberu';
        font-weight: normal;
        font-size: 1rem;
        margin-right: 0.7rem;
      }
    }
  }

  .reseller-location {
    &:before {
      content: '\e80e';
    }
  }

  .reseller-phone {
    &:before {
      content: '\e811';
    }
  }

  .reseller-link {
    text-decoration: underline;
    &:before {
      content: '\e81e';
    }
  }

  .reseller-row.country-mismatch,
  .reseller-row.search-mismatch {
    display: none;
  }

  .reseller-row.even {
    background: #fff;
    text-align: left;
  }

  .reseller-row.odd {
    background: ${({ theme }) => theme.colors.themeGrey};
    text-align: left;
  }

  .col,
  .cell {
    display: table-cell;
    padding: 0.8em;
    font-size: 0.7rem;
  }

  .reseller-row a {
    color: ${({ theme }) => theme.colors.themeBlack};
  }

  ${({ theme }) => theme.below.md} {
    .top-buttons-container {
      margin: 0 0 10px 0;
      text-align: center;

      & > div {
        flex: 1 1 100%;
        //margin: .65em 1%;
        width: 50%;
        text-align: center;
      }
      .button-right {
        //  text-align: right;
      }
    }
    .reseller-countries {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin: 0;
    }
    .reseller-country-filter {
      flex: 0 1 48%;
      margin: 0.5em 1%;
      padding: 1em 1em;
      font-size: 0.75rem;
    }
  }
`;

const Header = styled('h1')`
  ${({ theme }) => theme.typography.h1}
  display: inline-block;
  position: relative;
  margin-bottom: 48px;
  text-transform: uppercase;
  font-weight: 800;
  letter-spacing: 1px;
  margin: 34px auto 56px;
  text-align: center;

  &:after {
    content: '';
    width: calc(100% - 20px);
    height: 7px;
    position: absolute;
    bottom: -1.25rem;
    left: 0;
    right: 0;
    margin: 0 auto;
    background: #000;
    max-width: 192px;
  }
`;

const Content = styled('div')`
  padding-bottom: 1rem;

  h1 {
    text-align: center;
  }

  h2 {
    font-size: 1.5rem;
    font-weight: 500;
    margin-bottom: ${({ theme }) => theme.space[1]};
  }

  h3 {
    font-size: ${({ theme }) => theme.typography.h3};
    font-weight: bold;
    margin-bottom: 0.5rem;
  }

  ul {
    list-style: bullet;
  }

  p {
    margin-bottom: 1.5rem;
  }

  img {
    width: 100%;
  }
`;

const MaxWidth = styled(UIMaxWidth)`
  max-width: 610px;
`;

const HeroImage = styled(Image)`
  padding-top: 0;
  height: 388px !important;
  background-size: cover;
  max-width: 1216px;
  margin: 0 auto;
`;

function ContentPage(props) {
  const { result, cacheHit } = props;
  const isRetailerPage = result.data.route.object.id === '54';

  let [renderedStores, setRenderedStores] = useState(false);

  useEffect(() => {
    if (isRetailerPage && typeof window !== 'undefined') {
      $(function($) {
        if ($('.resellers-wrapper').length) return;
        if ($('.category-page-wrapper').length === 0) {
          return;
        }

        if (renderedStores === true) {
          return;
        }

        var language = document.getElementById('channel')
          ? document.getElementById('channel').getAttribute('data-channel')
          : null;

        /* Values */
        var countryCodes = {
            SE: {
              all: 'Alla',
              at: 'Österrike',
              ch: 'Schweiz',
              de: 'Tyskland',
              dk: 'Danmark',
              fi: 'Finland',
              jp: 'Japan',
              no: 'Norge',
              nl: 'Nederländerna',
              ru: 'Ryssland',
              se: 'Sverige',
              sk: 'Slovakien',
              cz: 'Tjeckien',
              uk: 'Storbritannien',
              us: 'USA',
              www: 'Webb',
              eu: 'EU',
              dis: 'Distributor',
              ro: 'Rumänien',
              fr: 'Frankrike',
              it: 'Italien',
              au: 'Australien',
              hu: 'Ungern'
            },
            FI: {
              all: 'All',
              at: 'Austria',
              ch: 'Switzerland',
              de: 'Germany',
              dk: 'Denmark',
              fi: 'Finland',
              jp: 'Japan',
              no: 'Norway',
              nl: 'Netherlands',
              ru: 'Russia',
              se: 'Sweden',
              sk: 'Slovakia',
              cz: 'Czech Republic',
              uk: 'United Kingdom',
              us: 'United States',
              www: 'Web Stores',
              store: 'Stores',
              eu: 'EU',
              dis: 'Distributor',
              ro: 'Romania',
              fr: 'France',
              it: 'Italy',
              au: 'Australia',
              hu: 'Hungary'
            }
          },
          tableHeadings = {
            SE: ['Butik', 'Adress', 'Telefon', 'Mail', 'Webb'],
            FI: ['Myymälä', 'Osoite', 'Puhelin', 'Sähköposti', 'Verkkokauppa']
          };

        var getResellersSuccess = function(data) {
          try {
            var rows = data.values;
            rows.splice(0, 1);
          } catch (error) {
            return null;
          }

          let resellersTable = $('<table class="resellers-table"></table>');
          let resellersTableHead = $('<tr class="resellers-head"></tr>');

          $.each(tableHeadings[language], function(_index, title) {
            $('<div class="retailer-title">' + title + '</div>').appendTo(
              resellersTableHead
            );
          });

          resellersTableHead.appendTo(resellersTable);

          $.each(rows, function(resellerIndex, reseller) {
            var rowClass = 'even';

            if (resellerIndex % 2 === 0) {
              rowClass = 'odd';
            }

            var $row = $('<div class="reseller-row"></div>').addClass(rowClass);

            $.each(reseller, function(columnIndex, columnValue) {
              let resellerColumn = reseller[columnIndex];
              var className = resellerColumn ? '' : ' empty-col';
              var $cell = $('<div class="cell' + className + '"></div>');

              if (columnIndex === 6) {
                var countryCode = resellerColumn.toLowerCase();
                $row.addClass('country-' + countryCode);

                if ($.inArray(countryCode, availableCountries) === -1) {
                  availableCountries.push(countryCode);
                }
              } else if (columnIndex === 5) {
                /*if(resellerColumn){
                  $('<a href="mailto:' + resellerColumn + '">Contact</a>').appendTo($cell);
                }

                $cell.appendTo($row);*/
              } else if (columnIndex === 4) {
                if (resellerColumn) {
                  $(
                    '<a href="' +
                      columnValue +
                      '" target="_blank">' +
                      resellerColumn +
                      '</a>'
                  ).appendTo($cell);
                }
                $cell.appendTo($row);
              } else {
                className = resellerColumn.length > 0 ? '' : ' empty-col';
                $(
                  '<div class="col' + className + '">' + columnValue + '</div>'
                ).appendTo($row);
              }
            });

            $row.appendTo(resellersTable);
          });

          availableCountries = availableCountries.sort(function(a, b) {
            a = countryCodes[language][a];
            b = countryCodes[language][b];

            if (a < b) {
              return -1;
            }
            if (a > b) {
              return 1;
            }
            return 0;
          });

          var resellerCountries = $('<div class="reseller-countries"></div>');
          $(
            '<button type="button" class="reseller-country-filter active">' +
              countryCodes[language]['all'] +
              '</button>'
          ).appendTo(resellerCountries);

          $.each(availableCountries, function(countryIndex, countryCode) {
            $(
              '<button type="button" class="reseller-country-filter" data-filter-country="' +
                countryCode +
                '">' +
                countryCodes[language][countryCode] +
                '</button>'
            ).appendTo(resellerCountries);
          });

          var resellersSearch = $(
            '<div class="resellers-search-form"><input type="text" id="resellers-search" class="resellers-search-input" placeholder="Sök"></div>'
          );

          /* Insert */

          $('<div class="resellers-wrapper"></div>').insertAfter(
            '.category-page-wrapper'
          );

          var pageContent = $('.resellers-wrapper');
          pageContent.html(resellerCountries);
          pageContent.append(resellersSearch);
          pageContent.append(resellersTable);

          $(
            '<div class="category-header-subtitle category-subtitle dealers-subtitle"><p></p></div>'
          ).insertAfter($('.category-page-wrapper'));

          /* Events */
          $('.reseller-country-filter').on('click', function() {
            var $this = $(this),
              countryCode = $this.attr('data-filter-country');
            //$this.siblings().removeClass('active');
            $('.reseller-country-filter.active').removeClass('active');
            $this.addClass('active');

            $('.reseller-row').removeClass('country-mismatch');

            if (countryCode) {
              $('.reseller-row')
                .not('.country-' + countryCode)
                .addClass('country-mismatch');
            }

            if (countryCode === 'www' || countryCode === 'dis') {
              $('.button-left button').removeClass('active');
            }

            $('.reseller-row')
              .not('.country-mismatch, .search-mismatch')
              .each(function(resellerIndex) {
                var rowClass = 'even';
                if (resellerIndex % 2 === 0) {
                  rowClass = 'odd';
                }

                $(this)
                  .removeClass('even odd')
                  .addClass(rowClass);
              });
          });

          $('#resellers-search')
            .on('keyup', function() {
              var searchValue = $(this).val();

              $('.reseller-row').each(function(resellerIndex) {
                var $this = $(this),
                  content = $this
                    .html()
                    .replace(/(<([^>]+)>)/gi, ' ')
                    .toLowerCase();

                if (content.indexOf(searchValue.toLowerCase()) === -1) {
                  $this.addClass('search-mismatch');
                } else {
                  $this.removeClass('search-mismatch');
                }
              });

              $('.reseller-row')
                .not('.country-mismatch, .search-mismatch')
                .each(function(resellerIndex) {
                  var rowClass = 'even';
                  if (resellerIndex % 2 === 0) {
                    rowClass = 'odd';
                  }

                  $(this)
                    .removeClass('even odd')
                    .addClass(rowClass);
                });
            })
            .on('keypress', function(e) {
              if (e.keyCode === 13) {
                return false;
              }
            });

          $('.reseller-row').on('click', function() {
            if ($(this).hasClass('active-tab')) {
              $(this).removeClass('active-tab');
              $(this)
                .find('.mobile-reseller-tab')
                .slideUp();
            } else {
              $('.reseller-row').removeClass('active-tab');
              $('.mobile-reseller-tab').slideUp();
              $(this).addClass('active-tab');
              $(this)
                .find('.mobile-reseller-tab')
                .slideDown();
            }
          });
        };

        /* Elements */

        var availableCountries = [];
        // Pre deprecation https://spreadsheets.google.com/feeds/list/19sgGqFgUiXuRnHTezNL9O80Kb2TPNJ6MWfwLC4nAA6M/1/public/full?alt=json,
        $.ajax(
          'https://sheets.googleapis.com/v4/spreadsheets/19sgGqFgUiXuRnHTezNL9O80Kb2TPNJ6MWfwLC4nAA6M/values/Butiker?key=AIzaSyC6BF1BA2TqbyxrvWRzhC6o5sI2z0VP4F8',
          {
            dataType: 'json',
            success: getResellersSuccess
          }
        );

        function waitFor(selector, callback) {
          setTimeout(internalWaitFor, 100);

          function internalWaitFor() {
            var $elements = $(selector);
            if ($elements.length) {
              callback($elements);
            } else {
              setTimeout(internalWaitFor, 100);
            }
          }
        }

        waitFor('.reseller-countries', function($switcher) {
          $('.reseller-country-filter').each(function() {
            if ($(this).text() === 'undefined') {
              $(this).hide();
            }
          });
          $('.resellers-wrapper').prepend(
            '<div class="top-buttons-container"><div class="button-left"></div><div class="button-right"></div></div>'
          );
          $('.reseller-country-filter:first-of-type').appendTo('.button-left');
          $('.reseller-country-filter[data-filter-country="www"]').appendTo(
            '.button-right'
          );
          $('.reseller-country-filter[data-filter-country="dis"]').appendTo(
            '.button-right'
          );

          $('.reseller-row').each(function() {
            if (
              $(this)
                .find('div:nth-child(3)')
                .text().length === 0 &&
              $(this)
                .find('div:nth-child(4)')
                .text().length === 0 &&
              $(this)
                .find('div:nth-child(5)')
                .text().length === 0
            ) {
              $(this).addClass('no-tab');
            } else {
              $(this)
                .clone()
                .removeClass()
                .addClass('mobile-reseller-tab')
                .appendTo($(this));
            }
          });

          $('.mobile-reseller-tab').each(function() {
            if (
              $(this)
                .find('div:nth-child(3)')
                .text().length > 0
            ) {
              $(this)
                .find('div:nth-child(3)')
                .addClass('reseller-location');
            }
            if (
              $(this)
                .find('div:nth-child(4)')
                .text().length > 0
            ) {
              $(this)
                .find('div:nth-child(4)')
                .addClass('reseller-phone');
            }
            if (
              $(this)
                .find('div:nth-child(5) a')
                .text().length > 0
            ) {
              $(this)
                .find('div:nth-child(5)')
                .addClass('reseller-link');
            }
          });
          setRenderedStores(true);
        });
      });
    }
  }, [renderedStores, isRetailerPage]);

  return (
    <ChannelContext.Consumer>
      {({ channels, selectedChannel, updateChannel }) => (
        <>
          {result.data.route.object.images.length > 0 && (
            <HeroImage
              src={result.data.route.object.images}
              aspect="13:3"
              cover
              fillAvailableSpace
            />
          )}

          <MaxWidth>
            {cacheHit ? (
              <>
                <Header
                  dangerouslySetInnerHTML={{
                    __html: result.data.route.object.name
                  }}
                />

                <Content
                  dangerouslySetInnerHTML={{
                    __html: result.data.route.object.content
                  }}
                />
              </>
            ) : (
              <LoadingLine
                heightPx={14}
                widthRem={30}
                randomizeWidthBy={10}
                count={10}
                className={css`
                  margin-bottom: 12px;
                `}
              />
            )}
          </MaxWidth>
          {isRetailerPage && (
            <StoreWrapper>
              <span id="channel" data-channel={selectedChannel.name} />
              {renderedStores || <div className="category-page-wrapper" />}
            </StoreWrapper>
          )}
        </>
      )}
    </ChannelContext.Consumer>
  );
}

export default ContentPage;
